import React from "react";
import Main from "./main";
import type { ItemProps } from "./types";

const Item = React.forwardRef<HTMLDivElement, ItemProps>(({ title, children, subtitle, ...rest }, ref) => (
  <Main ref={ref} {...rest}>
    {title && <p className="mb-0">{title}</p>}
    {subtitle && <span className="mt-2 font-size-2 text-muted">{subtitle}</span>}
    {children}
  </Main>
));

export default Item;
